import type { FC } from "react";

import { LinkContainer } from "./BusinessSocialMediaLink.styles";

export interface BusinessSocialMediaLinkProps {
  icon: React.ElementType;
  link: string;
}

const BusinessSocialMediaLink: FC<BusinessSocialMediaLinkProps> = ({ icon: Icon, link }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <LinkContainer>
        <Icon />
      </LinkContainer>
    </a>
  );
};

export default BusinessSocialMediaLink;
